import React from "react";
import styles from "./FormConsent.module.css";

/**
 * @param {'light'|'dark'} theme
 */
export function FormConsentFields({
  theme = "light",
  consentPd,
  setConsentPd,
  consentOferta,
  setConsentOferta,
  consentMarketing,
  setConsentMarketing,
  showConsentError,
  formError,
  onClearError,
}) {
  const root =
    theme === "dark"
      ? `${styles.formConsents} ${styles.checkboxGroupDark}`
      : styles.formConsents;

  return (
    <div className={root}>
      <label
        className={`${styles.consentRow} ${
          showConsentError && !consentPd ? styles.errorRow : ""
        }`}
      >
        <input
          type="checkbox"
          checked={consentPd}
          onChange={(e) => {
            setConsentPd(e.target.checked);
            onClearError?.();
          }}
        />
        <span>
          Согласен(а) на{" "}
          <a href="/privacy-policy" target="_blank" rel="noreferrer">
            обработку персональных данных
          </a>{" "}
          (обязательно)
        </span>
      </label>

      <label className={`${styles.consentRow} ${styles.marketing}`}>
        <input
          type="checkbox"
          checked={consentMarketing}
          onChange={(e) => setConsentMarketing(e.target.checked)}
        />
        <span>Хочу получать информацию о скидках и акциях</span>
      </label>

      <label
        className={`${styles.consentRow} ${
          showConsentError && !consentOferta ? styles.errorRow : ""
        }`}
      >
        <input
          type="checkbox"
          checked={consentOferta}
          onChange={(e) => {
            setConsentOferta(e.target.checked);
            onClearError?.();
          }}
        />
        <span>
          Принимаю{" "}
          <a href="/oferta" target="_blank" rel="noreferrer">
            условия публичной оферты
          </a>{" "}
          (обязательно)
        </span>
      </label>

      {(formError || (showConsentError && (!consentPd || !consentOferta))) && (
        <p className={styles.formErrorMsg}>
          {formError ||
            "Необходимо дать согласие на обработку ПДн и принять оферту"}
        </p>
      )}
    </div>
  );
}
